import { z } from 'zod';

export const FEATURE_FLAGS = {
  deliveryRoomEnabled: {
    key: 'delivery-room-enabled',
    description: 'Controls Delivery Room availability',
  },
  userManagementEnabled: {
    key: 'user-management-enabled',
    description: 'Controls user management availability',
  },
  accountPermissionEnabled: {
    key: 'account-permission-enabled',
    description: 'Controls Account Permission availability',
  },
  permissionAssignListEnabled: {
    key: 'permission-assign-list-enabled',
    description:
      'Controls Permission Group assign list availability (not yet wired to API)',
  },
  individualPermissionEnabled: {
    key: 'individual-permission-enabled',
    description:
      'Controls Account Permission individual permission add/edit/delete actions availability',
  },
  batchAssignPermissionEnabled: {
    key: 'batch-assign-permission-enabled',
    description: 'Controls batch permission assignment availability',
  },
  myPatientEnabled: {
    key: 'my-patient-enabled',
    description: 'Controls My Patient module availability',
  },
  dailyCareEnabled: {
    key: 'daily-care-enabled',
    description: 'Controls Daily Care module availability',
  },
  patientEducationEnabled: {
    key: 'patient-education-enabled',
    description: 'Controls Patient Education module availability',
  },
  doctorDashboardEnabled: {
    key: 'doctor-dashboard-enabled',
    description: 'Controls Doctor Dashboard availability',
  },
  formQrcodeEnabled: {
    key: 'form-qrcode-enabled',
    description: 'Controls form QR code action availability',
  },
  formAnalyticsEnabled: {
    key: 'form-analytics-enabled',
    description: 'Controls form analytics menu availability',
  },
  draftFeaturesEnabled: {
    key: 'draft-features-enabled',
    description:
      'Controls draft, not-yet-finalized placeholder UI in the app shell',
  },
} as const;

export type FeatureFlagName = keyof typeof FEATURE_FLAGS;

export type FeatureFlagValues = {
  [Name in FeatureFlagName]: boolean;
};

const featureFlagShape = Object.fromEntries(
  Object.keys(FEATURE_FLAGS).map((name) => [name, z.boolean()]),
) as { [Name in FeatureFlagName]: z.ZodBoolean };

export const featureFlagValuesSchema = z.object(featureFlagShape).strip();

const createFeatureFlagValues = (value: boolean): FeatureFlagValues =>
  Object.fromEntries(
    Object.keys(FEATURE_FLAGS).map((name) => [name, value]),
  ) as FeatureFlagValues;

export const LOCAL_FEATURE_FLAG_VALUES = createFeatureFlagValues(true);
export const FEATURE_FLAG_EVALUATION_DEFAULTS = createFeatureFlagValues(false);
